import React, { Component } from 'react';

import _ from 'lib/lodash'

import './CardListHeader.css';

class CardListHeader extends Component {
	shouldComponentUpdate(nextProps, nextState) {
		/* re-render only if number of nodes has changed */
		return _.size(nextProps.nodes) !== _.size(this.props.nodes);
	}

	render() {
		const { nodes } = this.props;
		const { title, titleOne, titleMany, showCount = true } = this.props;

		const count = _.size(nodes);
		const titleString =
			title ? title :
			count === 0 ? "" :
			count === 1 ? `${showCount ? "1 " : ""}${titleOne}` :
			`${showCount ? count + " " : ""}${titleMany}`;

		const renderContent = () => (
			<div className="card-list-header sticky-header">
				<div className="title"><h3>{titleString}</h3></div>
			</div>
		);

		return count > 0 && title !== " " && renderContent();
	}
}

export default CardListHeader;



// WEBPACK FOOTER //
// ./src/components/cards/common/list/v1/CardListHeader.jsx